module.exports = __webpack_public_path__ + "static/media/dm.c80e3f34.svg";